import { isNil } from "@s-libs/micro-dash";

/**
 * returns a string with an English representation of this number (e.g. 20000 => 20,000).
 * @param {number} number - a number to be formatted as a string using a comma as a thousand separator
 *
 * @return {string} formatted number
 */
const getCommaSeparatedNumericString = (number) => {
  if (isNil(number)) return null;

  if (isNaN(parseInt(number))) return null;

  return Number(number).toLocaleString("en-US");
};

export default getCommaSeparatedNumericString;
